<template>
  <v-app-bar
    app
    flat
    dark
    height="2.75rem"
    class="navbar-compacto"
  >
    <!-- Logo -->
    <!-- <v-toolbar-title class="navbar-logo">
      <img
        src="@/assets/logos/logoEmpresa.png"
        alt="Logo"
      />
    </v-toolbar-title> -->

    <router-link to="/" class="logo-link">
      <v-img
          :src="site.logo_url || defaultLogo"
          max-height="40"
          max-width="40"
          contain
          class="mr-3"
      />

    </router-link>

    <!-- Navegación de escritorio -->
    <v-spacer />

    
    



      <!-- Desktop -->
        <div class="nav-links hidden-sm-and-down">

            <v-btn
                v-for="item in navigationItems"
                :key="item.id || item.url"
                class="nav-btn"
                text
                :to="item.url"
            >{{ item.label }}</v-btn>

        </div>

        <!-- Mobile -->
        <div class="hidden-md-and-up">

            <v-menu
                offset-y
                left
                :z-index="1000"
                content-class="navbar-mobile-menu"
            >

                <template v-slot:activator="{ on, attrs }">

                    <v-btn
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >

                        <v-icon>

                            mdi-menu

                        </v-icon>

                    </v-btn>

                </template>

                <v-list>

                    <v-list-item
                        v-for="item in navigationItems"
                        :key="item.id || item.url"
                        :to="item.url"
                        link
                    >
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item>


                </v-list>

            </v-menu>

        </div>





  </v-app-bar>
</template>

<script>
import { loadSiteConfig, siteState } from "@/site/siteConfig";

export default {
  name: "NavBar",
  computed: {
    site() {
      return siteState.data.site || {};
    },
    defaultLogo() {
      return require("@/assets/images/logoPequenio.png");
    },
    navigationItems() {
      return (siteState.data.navigation || [])
        .filter((item) => item.enabled !== false)
        .slice()
        .sort((left, right) => Number(left.sort_order || 0) - Number(right.sort_order || 0));
    },
  },
  mounted() {
    loadSiteConfig().catch(() => {});
  },
};
</script>

<style scoped>

.v-main {
  /* padding: 0 !important; */
  /* height: 2rem !important; */
}

.navbar-compacto {
  padding: 0 !important;
  height: 2.75rem !important;
  min-height: 2.75rem !important;
  z-index: 900 !important;
}

/*
 * Este es el contenedor interno real que genera Vuetify.
 * Debe tener la misma altura que el app-bar.
 */
.navbar-compacto::v-deep .v-toolbar__content {
  height: 2.75rem !important;
  min-height: 2.75rem !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: center !important;
}

.nav-links {
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
}

.nav-btn {
  flex: 0 0 auto;
  height: 100% !important;
  margin: 0 !important;
  text-transform: none !important;
}

/* Logo */
.navbar-logo {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 1rem !important;
}

.navbar-logo img {
  display: block;
  width: auto;
  height: 1.9rem;
  max-height: 80%;
  object-fit: contain;
}

/* Opciones desktop */
.navbar-items {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

.navbar-items .v-btn {
  height: 100% !important;
  min-height: 100% !important;
  min-width: auto !important;
  margin: 0 !important;
  padding-inline: 0.8rem !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  font-size: 0.86rem;
  line-height: 1;
  text-transform: none;
  white-space: nowrap;
}

/*
 * El texto del botón está dentro de .v-btn__content.
 * También lo centramos porque es un elemento interno de Vuetify.
 */
.navbar-items .v-btn::v-deep .v-btn__content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

/* Botón hamburguesa */
.menu-btn {
  width: 2rem !important;
  height: 2rem !important;
  min-width: 2rem !important;
  align-self: center;
}

.menu-btn::v-deep .v-btn__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mobile */
@media (max-width: 600px) {
  .nav-links {
    display: none !important;
  }
  .navbar-logo {
    padding-left: 0.5rem !important;
  }

  .navbar-logo img {
    height: 1.7rem;
  }

  .menu-btn {
    width: 2.2rem !important;
    height: 2.2rem !important;
    min-width: 2.2rem !important;
  }

  .logo-link{

    display:flex;

    align-items:center;

    text-decoration:none;

  }

  .logo-text{

      font-size:1.7rem;

      font-weight:700;

      color:white;

      letter-spacing:.08em;

  }

  .logo-link .v-image{

      flex-shrink:0;

  }

  @media(max-width:960px){

  .logo-text{

  font-size:1.2rem;

  }

  .logo-link .v-image{

  max-width:38px !important;

  max-height:38px !important;

  }

  }

}
</style>

<style>
.navbar-mobile-menu {
  z-index: 1000 !important;
  pointer-events: auto !important;
}
</style>
